const Outlet = () => {
  return (
    <div style={{ color: '#FFFFFF' }}>
      <h2>404</h2>
      <h2>Page Not Found</h2>
    </div>
  );
};
export default Outlet;
